import React from 'react'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import NewFormWizard from '../../../../components/formWizard/NewFormWizard'
import NewFormWizardChild from '../../../../components/formWizard/NewFormWziardChild'
import Layout from '../../../../components/layouts/Layout'
import { LoadingSpinner } from '../../../../components/Loader/Loader'
import http from '../../../../config/BaseUrl'
import { eventSmsSharing } from '../slice/createEventSlice'

const TextSms = () => {
    const history = useHistory()
    const dispatch = useDispatch()
    // const eventId   = history.location.state
    const { event_option, sms_sharing, eventId } = useSelector(state => state.createEvent)
    const [loading, setLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState("");
    const [grlErrMessage, setGrlErrorMessage] = useState("");
    const [grlCustomMessageError, setGrlCustomMessageError] = useState("");
    const [draftLoading, setDraftLoading] = useState(false)
    const { register, handleSubmit, setValue, watch,  formState: { errors } } = useForm({
        mode: "all",
        reValidateMode: "onChange",
        defaultValues: {
            text_message: sms_sharing.text_message,
            google_review_custom_message: sms_sharing.google_review_custom_message || '',
            google_review_link: sms_sharing.google_review_link || '',
            google_review_message_delay: sms_sharing.google_review_message_delay || '1',
        }

    })
    const textMessage = watch("text_message");
    const textMessageCount = (textMessage || "").length;
    const googleReviewLink = watch("google_review_link");
    const googleReviewCustomMessage = watch("google_review_custom_message");
    const googleReviewCustomMessageCount = (googleReviewCustomMessage || "").length;

    const handleTextChange = (event) => {
        const value = event.target.value.slice(0, 130);
        const emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu; // Regex to match a wide range of emojis

        if (!emojiRegex.test(value)) {
            setErrorMessage("");
            setValue("text_message", value);
        } else {
            setErrorMessage("");
            setValue("text_message", value);
        }
    };
    const handelSMS = async (data) => {
        const emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu; // Regex to match a wide range of emojis

        if (emojiRegex.test(data.text_message)) {
            setErrorMessage("Emojis are not allowed in the text message.");
            return;
        }

        if (data.text_message && data.text_message.length > 130) {
            setErrorMessage("Text message should not exceed 130 characters.");
            return;
        }

        if (data.google_review_link && !/^https?:\/\/[^\s]+$/.test(data.google_review_link)) {
            setGrlErrorMessage("Please enter a valid URL.");
            return;
        }

        if (emojiRegex.test(data.google_review_custom_message)) {
            setGrlCustomMessageError("Emojis are not allowed in the automated follow up message.");
            return;
        }
        if (data.google_review_custom_message && data.google_review_custom_message.length > 100) {
            setGrlCustomMessageError("Automated follow up message should not exceed 100 characters.");
            return;
        }

        setErrorMessage("");
        setGrlErrorMessage("");
        setGrlCustomMessageError("");

        dispatch(eventSmsSharing(data))
        setLoading(true)
        http.post("text-sms", { ...data, eventId }).then(res => {
            if (res.data.text_sms.draft_status === 'draft') {
                setLoading(false)
                    if (event_option.digital_props      === true) { history.push('/event/digital-prop', eventId) }
                else if (event_option.water_mark        === true) { history.push('/event/custom-branding', eventId) }
                else if (event_option.microsite         === true) { history.push('/event/microsite', eventId) }
                else if (event_option.frame_option      === true) { history.push('/event/frame', eventId) }
                else if (event_option.incentive_offer   === true) { history.push('/event/incentive-offer', eventId) }
                else if (event_option.filters           === true) { history.push('/event/filter', eventId) }
                else if (event_option.form_builder === true) { history.push('/event/form-builder', eventId) }
                else { history.push('/event/summary', eventId) }
            }
        }).catch()


    }

    const saveAsDraft = () => {
        handleSubmit(async (data) => {
            const emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu; // Regex to match a wide range of emojis

            if (emojiRegex.test(data.text_message)) {
                setErrorMessage("Emojis are not allowed in the text message.");
                return;
            }

            if (data.text_message && data.text_message.length > 130) {
                setErrorMessage("Text message should not exceed 130 characters.");
                return;
            }

            if (data.google_review_link && !/^https?:\/\/[^\s]+$/.test(data.google_review_link)) {
                setGrlErrorMessage("Please enter a valid URL.");
                return;
            }
            if (emojiRegex.test(data.google_review_custom_message)) {
                setGrlCustomMessageError("Emojis are not allowed in the automated follow up message.");
                return;
            }
            if (data.google_review_custom_message && data.google_review_custom_message.length > 100) {
                setGrlCustomMessageError("Automated follow up message should not exceed 100 characters.");
                return;
            }

            setErrorMessage("");
            setGrlErrorMessage("");
            setGrlCustomMessageError("");

            dispatch(eventSmsSharing(data))
            setDraftLoading(true)
            http.post("text-sms", { ...data, eventId }).then(res => {
                if (res.data.text_sms.draft_status === 'draft') {
                    setDraftLoading(false)
                }
            }).catch(err => {
                setDraftLoading(false)
            })

        })()
    }
    const BackToPreviousPage = (e) => {
        e.preventDefault()
               if (event_option.email          === true) { history.push('/event/email') }
          else if (event_option.brust_gif      === true) { history.push('/event/brust-gif') }
          else if (event_option.gif            === true) { history.push('/event/gif') }
          else if (event_option.social_media   === true) { history.push('/event/social') }
          else { history.push('/event/options') }
    }

    return (
        <Layout>
            <style>
                {`
                .form-control::placeholder {
                    color: #6c757d !important;
                    opacity: 0.5 !important;
                    font-weight: 400 !important;
                }

                textarea.form-control::placeholder {
                    color: #6c757d !important;
                    opacity: 0.5 !important;
                    font-weight: 400 !important;
                }
                `}
            </style>
            <NewFormWizard />
            <NewFormWizardChild />
            <section className="mt-4">
                <div className="row justify-content-center">
                    <div className="col-md-10">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="text-center col-12 col-md-12">
                                        <div className="">
                                            <p className="mb-0 display-4 text-primary event-form-title">Text Messaging</p>
                                            <p className="mb-0 text-secondary">SMS settings</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <form onSubmit={handleSubmit(handelSMS)} >
                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <div className="card">
                                <div className="card-body">
                                    <div className="form-group">
                                        <label className="col-form-label">Text Messaging *</label>
                                        <textarea placeholder="EG - Thank you for visiting! Special offer coming your way within 24 hours!" id="TMS-TM" cols="30" rows="2" className="form-control" {...register("text_message", { required: true })} value={textMessage} onChange={handleTextChange} maxLength={130} ></textarea>
                                        <small className="text-muted d-block text-right mt-1">
                                            {textMessageCount}/130 characters
                                        </small>
                                        <span className="text-danger font-size-14">{errors.text_message && errors.text_message.message}</span>
                                        <span className="text-danger font-size-14">{errorMessage}</span>
                                    </div>

                                    <div className='form-group row'>
                                        <div className="form-group col-md-12">
                                            <label htmlFor="">Automated Follow Up SMS Message </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Irresistible offer. EG - Spend $75, save $15 off your bill. Show the bar this SMS. Expires [date]."
                                                {...register("google_review_custom_message", { required: false })}
                                                value={googleReviewCustomMessage}
                                                maxLength={100}
                                            />
                                            <small className="text-muted d-block text-right mt-1">
                                                {googleReviewCustomMessageCount}/100 characters
                                            </small>
                                            <span className="text-danger font-size-14">{errors.google_review_custom_message && errors.google_review_custom_message.message}</span>
                                            <span className="text-danger font-size-14">{grlCustomMessageError}</span>
                                        </div>
                                    </div>

                                    <div className='form-group row'>
                                        <div className="form-group col-md-12">
                                            <label htmlFor="">What do you want guests to click on?</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Paste your link here (e.g. Google Review, booking form, or event page URL)"
                                                {...register("google_review_link", { required: false })}
                                                value={googleReviewLink}
                                            />
                                            <span className="text-danger font-size-14">{errors.google_review_link && errors.google_review_link.message}</span>
                                            <span className="text-danger font-size-14">{grlErrMessage}</span>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-sm-6 col-form-label">When to Send Automated Follow Up SMS</label>
                                        <div className="col-sm-6">
                                            <select className="form-control" style={{ maxWidth: '220px' }} {...register("google_review_message_delay")}>
                                                <option value="11">11 AM</option>
                                                <option value="16">4 PM</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-sm-6 col-form-label">Send</label>
                                        <div className="col-sm-6">
                                            <select className="form-control" style={{ maxWidth: '220px' }} {...register("send")}>
                                                <option value="1" selected={sms_sharing.send && sms_sharing.send === "1" ? "selected" : ""}>Social Gallery link</option>
                                            </select>
                                        </div>
                                    </div>
                                    {/* <div className="form-group row">
                                        <label className="col-sm-6 col-form-label">Country</label>
                                        <div className="col-sm-6">
                                            <select className="form-control" {...register("country")}>
                                                {countryDialList.map((res) => {
                                                    return (
                                                        <option selected={sms_sharing.country === res.dialCode} value={res.dialCode} >{res.dialCode}  {res.name}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="my-5 row justify-content-center">
                        <div className="col-md-10">
                            <button type="button" onClick={BackToPreviousPage} className="float-left px-5 btn btn-outline-secondary radius-10">Back</button>
                            {loading ?
                                (<button className="float-right px-5 btn btn-primary radius-10" disabled>
                                    <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                </button>)
                                : <button type="submit" disabled={draftLoading} className="float-right px-5 btn btn-primary radius-10">Next</button>
                            }
                            {
                                loading ?
                                    (<button className="float-right px-3 mr-2 btn btn-secondary radius-10" disabled>
                                        <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                    </button>)
                                    :
                                    <button type="button" onClick={saveAsDraft} className="float-right px-3 mr-2 btn btn-secondary radius-10">Save as draft</button>
                            }
                        </div>
                    </div>
                </form>
            </section>
        </Layout>
    )
}

export default TextSms
